// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"969a49d2","498":"f035a364","551":"ab63c289","627":"e2ef4ee1","653":"2cd542af","738":"feb0646f","923":"9c0fc49f"}[chunkId] + ".chunk.js";
};